import React from 'react';
import { Link } from 'react-router-dom';
import SITE_CONFIG from '../config/site.config';
import './Legal.css';

const Privacy = () => {
  return (
    <>
      <div className="page-header">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <h2>Privacy Policy</h2>
            </div>
            <div className="col-12">
              <Link to="/">Home</Link>
              <Link to="/privacy">Privacy Policy</Link>
            </div>
          </div>
        </div>
      </div>

      <div className="about legal-page">
        <div className="container">
          <div className="section-header">
            <p>Legal</p>
            <h2>Privacy Policy</h2>
          </div>

          <div className="legal-content">
            <p>
              This website is operated and owned by {SITE_CONFIG.name} — {SITE_CONFIG.title}.
              This Privacy Policy Statement is published to protect users&apos; privacy and is
              connected to our <Link to="/terms">Terms &amp; Conditions</Link>.
            </p>

            <p>
              When you use our website after accepting our Terms &amp; Conditions, you may be
              asked to provide mandatory information. You have the option of not providing
              information that is not mandatory. You are solely responsible for maintaining the
              confidentiality of your user identity and password, and for all activities performed
              through your account. {SITE_CONFIG.name} assumes no responsibility for improper use
              of payment instruments or documents used in online or offline transactions resulting
              from your negligence.
            </p>

            <p>
              We may use your IP address, email address, contact name, address, pin code, telephone
              number, and other information you provide to help diagnose server problems, manage our
              website, and contact you with information relevant to your use of the site — such as
              announcements, product offerings, and administrative notices. By using our services and
              submitting forms on this website, you consent to receive communications from us via
              SMS, email, WhatsApp, RCS, or phone, as described in our Terms &amp; Conditions.
            </p>

            <p>
              Unless you give your consent, we do not sell, rent, share, trade, or give away your
              personal information to third parties. Users who have provided contact information for
              listings or enquiries on our platform may be contacted in response to their requests
              through us.
            </p>

            <p>
              We may update this Privacy Policy from time to time without prior notice. We encourage
              you to review this page periodically to stay informed of any changes.
            </p>

            <p>
              {SITE_CONFIG.name} strives to provide accurate and clear information but cannot be
              held liable for errors or inconsistencies on the website. We disclaim responsibility
              for the accuracy, content, completeness, legality, reliability, or availability of
              information or material displayed by third parties on this website.
            </p>

            <p>
              For further clarifications, please <Link to="/contact">contact us</Link> or email{' '}
              <a href={`mailto:${SITE_CONFIG.email}`}>{SITE_CONFIG.email}</a>.
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default Privacy;
